import $axios from "@utils/axios";
// import { isCn } from "@utils/general";
import { toast } from "react-hot-toast";

export const loginAction = async (
  values: any,
  setIsLoading: any,
  handleReCaptchaVerify: any,
  dispatchToken: any,
  dispatchCustomer: any,
  dispatchLogged: any
): Promise<string | null> => {
  setIsLoading(true);
  try {
    const res = await $axios.post("auth/login", {
      ...values,
      reToken: await handleReCaptchaVerify(),
    });

    if (res?.data && res?.data?.success) {
      const token = res.data.token;
      dispatchToken(token);
      console.log("token: ", token);

      console.log("token2:");
      const cust = await $axios.get<any>("auth/me", values);

      dispatchCustomer(cust.data.data);
      dispatchLogged(true);
      if (
        !cust.data.data.pwd.customer_dashboard_pwd ||
        !cust.data.data.pwd.customer_login_pwd
      ) {
        location.href = `/change-password`;
      } else {
        location.href = "/dashboard";
      }
    } else {
      if (
        res?.data?.success === false &&
        res?.data?.message === "Customer Not Active"
      ) {
        setIsLoading(false);
        return "Customer Not Active";
      } else if (
        res?.data?.success === false &&
        res?.data?.message === "password to short"
      ) {
        setIsLoading(false);
        return "password to short";
      }
    }
    setIsLoading(false);

    return null;
  } catch (e: any) {
    setIsLoading(false);
    console.error(e);
    toast.error(e?.message || "Error while login");
    return null;
  }
};
